import React from 'react';
import { Zap, Loader2 } from 'lucide-react';
import type { ToolCall } from '../../types';
import type { WidgetStrings } from '../../utils/i18n';
import { DEFAULT_WIDGET_STRINGS } from '../../utils/i18n';

interface ActiveToolCallsProps {
  toolCalls: ToolCall[];
  strings?: WidgetStrings;
}

const ActiveToolCalls = React.memo(function ActiveToolCalls({
  toolCalls,
  strings = DEFAULT_WIDGET_STRINGS,
}: ActiveToolCallsProps) {
  if (toolCalls.length === 0) return null;
  return (
    <div className="flex items-start mb-4" role="status" aria-live="polite">
      <div className="max-w-[80%] rounded-2xl px-4 py-2 border shadow bg-white border-gray-200">
        <div className="text-xs text-gray-600 mb-2">{strings.runningTools}</div>
        {toolCalls.map(tool => (
          <div
            key={tool.id}
            className="bg-blue-50 border border-blue-200 rounded p-2 mb-2 last:mb-0"
          >
            <div className="flex items-center gap-2 text-xs">
              <Zap className="w-3 h-3 text-blue-600" aria-hidden="true" />
              <span className="font-semibold">{tool.name}</span>
              <Loader2 className="w-3 h-3 animate-spin text-blue-600" aria-hidden="true" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
});

export default ActiveToolCalls;
